
import { defineComponent, onBeforeMount, onUnmounted, ref, computed } from 'vue';
// import axios from 'axios';
import { XIcon } from 'vue-feather-icons';
// eslint-disable-next-line
import { getPreSignedUrl, restarLearnerJourney, uploadSubmission, updateLearnerSubmission, updateGenAISubmission, fetchGenAIResponse } from '@/utils/learner_submit_service';
import { getExistedLearner } from '@/utils/select_task_service';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import Greetings from '@/components/global/Greetings.vue';
import AILoader from '@/components/global/AILoader.vue';
import StarRating from '@/components/global/StarRating.vue';
import moment from 'moment';

// eslint-disable-next-line
import router from '@/router';

export default defineComponent({
  name: 'LearnerSubmitTask',
  components: { XIcon, ErrorMessage, Greetings, AILoader, StarRating },
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const taskId = ref();
    const learnerTaskId = ref(props.query.learner_task_id);
    const programId = ref(localStorage.getItem('programId'));
    const skillId = ref(localStorage.getItem('skillId'));
    const proficiencyId = ref(localStorage.getItem('profId'));
    const skillName = ref(localStorage.getItem('skillName'));
    const profName = ref(localStorage.getItem('proficiency'));
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    const loadingGenAIResponse = ref(false);
    const genAIPromptResp = ref();
    const userRating: any = ref(0);
    const userComment: any = ref('');
    const stat: any = ref();
    const taskName = ref();
    const taskDesc = ref();
    const taskType = ref();
    const linkedTask = ref();
    const checkForPlagiarismTaskLevel = ref();
    const checkForPlagiarismProgramLevel = ref(false);
    const learnerSubmissionFile: any = ref(null);
    const fileValidationMsg = ref();
    const learnerSubmission = ref();
    const preSignedUrl = ref();
    const buttonDisable = ref(true);
    const plagiarismcb = ref([]);
    const validationError = ref();
    const palgiarismErrorMsg = ref();
    const fileInputKey = ref(0);
    const learnerStatus = ref();
    const renderReady = ref(false);
    const errorResponse = ref();
    const showErrorMessage = ref(false);
    const programName = ref();
    const taskAssignmentStrategy = ref();
    const reviewerAssignmentStrategy = ref();
    const questionWordCount = ref(0);
    const minimumWordLength = ref(100);
    const submissionError = ref('');
    const reviewPopupOpened = ref(false);
    let pollInterval: any = null;

    const fetchMinimumWordLength = () => {
      console.log('fetchMinimumWordLength is called');
      if (profName.value === 'Beginner') minimumWordLength.value = 150;
      if (profName.value === 'Intermediate') minimumWordLength.value = 250;
      if (profName.value === 'Proficient') minimumWordLength.value = 350;
      if (profName.value === 'Expert') minimumWordLength.value = 350;
    };

    const isEligibleForAIAssist = computed(() => {
      const ab = learnerSubmissionFile.value?.name?.split('.')?.pop()?.toLowerCase();
      if (ab === 'doc' || ab === 'docx' || ab === 'txt' || ab === 'pdf' || taskType.value === 'Mobile') return true;
      return false;
    });

    const checkQuestionLength = (ques: string) => {
      questionWordCount.value = ques.split(' ').filter((word: string) => word !== '').length;
      buttonDisable.value = questionWordCount.value < minimumWordLength.value;
    };
    const clearFile = async () => {
      fileInputKey.value += 1;
      console.log(`before ${learnerSubmission.value}`);
      learnerSubmission.value = null;
      buttonDisable.value = true;
      console.log(`after ${learnerSubmission.value}`);
    };
    const proceedToReview = () => {
      if (checkForPlagiarismProgramLevel.value && checkForPlagiarismTaskLevel.value && plagiarismcb.value.length < 4) {
        renderReady.value = true;
        palgiarismErrorMsg.value = 'Please confirm that you abide by the above statements';
        setTimeout(() => {
          palgiarismErrorMsg.value = null;
        }, 6000);
        return;
      }
      if (!(checkForPlagiarismProgramLevel.value && checkForPlagiarismTaskLevel.value) && plagiarismcb.value.length !== 1) {
        renderReady.value = true;
        palgiarismErrorMsg.value = 'Please confirm that you abide by the above statements';
        setTimeout(() => {
          palgiarismErrorMsg.value = null;
        }, 6000);
        return;
      }
      if (stat.value?.taskDetails?.genAiAssistEnabled && stat.value?.genAiAssistDetails?.length > 0) reviewPopupOpened.value = true;
      else submitSubmiision('submit_task');
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        // eslint-disable-next-line prefer-destructuring
        learnerSubmissionFile.value = event.target.files[0];
        if (learnerSubmissionFile.value) {
          learnerSubmission.value = event.target.files[0].name;
          const fileSize = event.target.files[0].size / 1024 / 1024;
          if (learnerSubmissionFile.value) {
            // console.log('selected Value');
            buttonDisable.value = false;
          }
          if (fileSize > 200) {
            fileValidationMsg.value = 'Uploaded filesize is greater than 200 MB';
            setTimeout(() => {
              fileValidationMsg.value = null;
            }, 6000);
            buttonDisable.value = true;
          }
        }
        // else {
        //   const data = {
        //     file_name: learnerSubmission.value,
        //     learner_task_id: learnerTaskId.value,
        //   };
        //   const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUploadLearner', data);
        //   preSignedUrl.value = preSignedRes.preSignedUrl;
        //   // fileName.value = preSignedRes.fileName;
        // }
      } catch (error) {
        console.log(error);
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'Something went wrong, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const submitSubmiision = async (btnAction: string) => {
      try {
        if (btnAction !== 'ai_assist') renderReady.value = false;
        console.log('plagiarismcb', plagiarismcb);
        if (checkForPlagiarismProgramLevel.value && checkForPlagiarismTaskLevel.value && plagiarismcb.value.length < 4) {
          renderReady.value = true;
          palgiarismErrorMsg.value = 'Please confirm that you will abide by the above statements';
          setTimeout(() => {
            palgiarismErrorMsg.value = null;
          }, 6000);
          return;
        }
        if (!(checkForPlagiarismProgramLevel.value && checkForPlagiarismTaskLevel.value) && plagiarismcb.value.length !== 1) {
          renderReady.value = true;
          palgiarismErrorMsg.value = 'Please confirm that you will abide by the above statements';
          setTimeout(() => {
            palgiarismErrorMsg.value = null;
          }, 6000);
          return;
        }
        // console.log('learner Submission inside if submit function', learnerSubmission.value);
        if (!learnerSubmission.value) {
          // console.log('learner Submission inside if condition', learnerSubmission.value);
          if (taskType.value === 'Mobile') {
            renderReady.value = true;
            if (!learnerSubmission.value) {
              fileValidationMsg.value = 'please Enter Submission';
              console.log('inside Mobile Type');
              setTimeout(() => {
                fileValidationMsg.value = null;
              }, 6000);
            }
          } else if (taskType.value === 'Desktop') {
            renderReady.value = true;
            console.log(`learnerSubmission.value ${learnerSubmission.value}`);
            if (!learnerSubmission.value) {
              fileValidationMsg.value = 'please select File';
              setTimeout(() => {
                fileValidationMsg.value = null;
              }, 6000);
            }
          }
        } else {
          if (btnAction === 'ai_assist' && stat.value?.taskDetails?.genAiAssistMaxAttempts - stat.value?.genAiAssistDetails?.length <= 0) return;
          if (btnAction === 'ai_assist') loadingGenAIResponse.value = true;

          const data = {
            learner_submission: learnerSubmission.value.trim(),
            learner_task_id: learnerTaskId.value,
            skill: skillId.value,
            proficiency: proficiencyId.value,
            linked_program_name: programId.value,
            task_type: taskType.value,
            linked_task_id: taskId.value,
            assinged_reviewer_count: 0,
          };
          // const data = {
          //   file_name: learnerSubmission.value,
          //   learner_task_id: learnerTaskId.value,
          // };
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          let invokeUpdateLearner: any;
          if (taskType.value === 'Desktop') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resPresSigned: any = await getPreSignedUrl('/v1/pretAuthUrlForUploadLearner', {
              file_name: learnerSubmission.value,
              learner_task_id: learnerTaskId.value,
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const preSignedRes: any = resPresSigned.data;
            // renderReady.value = true;
            preSignedUrl.value = preSignedRes.preSignedUrl;
            // renderReady.value = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const uploadedRes: any = await uploadSubmission(preSignedUrl.value, learnerSubmissionFile.value);
            // renderReady.value = true;
            if (uploadedRes.status === 200) {
              // renderReady.value = false;
              if (btnAction === 'ai_assist') {
                await proceedToGenAIAssist({
                  learner_submission: learnerSubmission.value,
                  learner_task_id: learnerTaskId.value,
                });
                return;
              } else invokeUpdateLearner = await triggerTaskSubmit(data);
              // renderReady.value = true;
            } else {
              renderReady.value = true;
              // localStorage.setItem('errorMsg', 'There is issue in the file upload, please contact with helpmate');
              // router.push({ path: 'Error' });
              errorResponse.value = 'There is issue in the file upload, please contact with helpmate.';
              showErrorMessage.value = true;
            }
          } else {
            // renderReady.value = false;
            if (btnAction === 'ai_assist') {
              await proceedToGenAIAssist({
                learner_submission: learnerSubmission.value.trim(),
                learner_task_id: learnerTaskId.value,
              });
              return;
            } else invokeUpdateLearner = await triggerTaskSubmit(data);
            // renderReady.value = true;
          }

          // const invokeUpdateLearner: any = await updateLearnerSubmission('/v1/uploadLearnerSubmission', data);
          // console.log('updateSubmission', invokeUpdateLearner);
          if (invokeUpdateLearner.status === 200) {
            console.log(invokeUpdateLearner);
            if (invokeUpdateLearner.data.message === 'Please upload non empty file') {
              submissionError.value = `The submission does not meet the minimum task word limit of ${minimumWordLength.value} words. Please upload a valid submission.`;
              clearFile();
              setTimeout(() => {
                submissionError.value = '';
              }, 6000);
              renderReady.value = true;
            } else {
              router.push({ name: 'SolidifyLearnerPeerReview', query: { learner_task_id: data.learner_task_id } });
            }
            if (invokeUpdateLearner.data.message === 'Learner on hold') {
              console.log('learner on hold submit task');
              router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: proficiencyId.value, program_id: programId.value } });
            }
          } else {
            renderReady.value = true;
            // modalMessage.value = 'There is issue in the file upload';
            // console.log('There is issue in the file upload');
            // renderReady.value = true;
            // localStorage.setItem('errorMsg', 'There is some issue while submitting learner submission, please contact with helpmate');
            // router.push({ path: 'Error' });
            errorResponse.value = 'There is some issue while submitting learner submission, please contact with helpmate.';
            showErrorMessage.value = true;
          }
        }
      } catch (error) {
        renderReady.value = true;
        console.log(`error ${error}`);
        // localStorage.setItem('errorMsg', 'There is some issue while submitting learner submission, please contact with helpmate');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is some issue while submitting learner submission, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const triggerTaskSubmit = async (data: any) => {
      let payload = data;
      if (stat.value?.taskDetails?.genAiAssistEnabled && stat.value?.genAiAssistDetails?.length > 0)
        payload = {
          ...data,
          genAiAssistLearnerFeedbackRating: userRating.value?.toString(),
          genAiAssistLearnerFeedbackComment: userComment.value,
        };
      const resp = await updateLearnerSubmission('/v1/uploadLearnerSubmission', payload);
      return resp;
    };
    const proceedToGenAIAssist = async ({ learner_submission, learner_task_id }) => {
      if (!isEligibleForAIAssist.value) return;
      genAIPromptResp.value = null;
      try {
        const invokeGenAIAssist = await updateGenAISubmission('/v1/uploadLearnerSubmission?submission_type=invoke_gen_ai_assist', { learner_submission, learner_task_id });
        if (invokeGenAIAssist.status === 200) {
          pollInterval = setInterval(async () => {
            try {
              const resp = await fetchGenAIResponse('/v1/uploadLearnerSubmission?submission_type=fetch_gen_ai_assist', {
                learner_task_id,
                prompt_execution_id: invokeGenAIAssist?.data?.data?.prompt_execution_id,
              });
              if (Object.keys(resp?.data?.data?.gen_ai_assist)?.length) {
                clearInterval(pollInterval);
                genAIPromptResp.value = resp?.data?.data?.gen_ai_assist;
                loadingGenAIResponse.value = false;
                const res: any = await getExistedLearner('/learner/journey/stat', { skill: skillId.value, proficiency: proficiencyId.value, program_id: programId.value });
                stat.value = res.data;
              }
            } catch (error: any) {
              console.error('Polling error:', error.message);
              loadingGenAIResponse.value = false;
              if (pollInterval) clearInterval(pollInterval);
            }
          }, 2000);
        } else if (invokeGenAIAssist.data.message) {
          console.log('Message =>', invokeGenAIAssist);
          loadingGenAIResponse.value = false;
          if (pollInterval) clearInterval(pollInterval);
        }
      } catch (error) {
        loadingGenAIResponse.value = false;
        if (pollInterval) clearInterval(pollInterval);
      }
    };

    const switchTask = async () => {
      try {
        renderReady.value = false;
        console.log('Learner Status', learnerStatus.value);
        if (learnerStatus.value !== 'Registered') {
          renderReady.value = true;
          console.log(`inside if ${learnerStatus.value}`);
          // localStorage.setItem('errorMsg', 'Learner Status is not registered');
          // router.push({ path: 'Error' });
          errorResponse.value = 'Learner Status is not registered.';
          showErrorMessage.value = true;
        } else {
          router.push({ name: 'SolidifyLearnerSelectTask', query: { skill_id: skillId.value, proficiency_id: proficiencyId.value, program_id: programId.value } });
        }
      } catch (error) {
        renderReady.value = true;
        // localStorage.setItem('errorMsg', 'There is an issue with the switching, please contact with helpmate');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue with the switching, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const restart = async () => {
      try {
        renderReady.value = false;
        if (learnerStatus.value !== 'Registered') {
          // console.log(`inside if ${learnerStatus.value}`);
          renderReady.value = true;
          // localStorage.setItem('errorMsg', 'Learner Status is not registered');
          // router.push({ path: 'Error' });
          errorResponse.value = 'Learner Status is not registered.';
          showErrorMessage.value = true;
        } else {
          // console.log('inside else');
          const restartLearnerJourney = await restarLearnerJourney('/v1/restartLearnerJourney', learnerTaskId.value);
          console.log('restartLearnerJourney', restartLearnerJourney);
          // renderReady.value = true;
          const restartMsg = 'your task was removed successfully, you can restart journey again from <a href="https://genome.genpact.com/#Myplan" target="_blank" class="text-background-secondary"><strong>MyPlan</strong></a>';
          if (restartLearnerJourney) {
            localStorage.setItem('message', restartMsg);
            router.push({ name: 'SolidifyLearnerStatus', query: { isPerformReviewVisible: 'no', isProxyReview: 'no', showChevron: 'no' } });
          } else {
            renderReady.value = true;
            // localStorage.setItem('errorMsg', 'There is an issue in the restart Journey');
            // router.push({ path: 'Error' });
            errorResponse.value = 'There is an issue in the restart Journey, please contact helpmate.';
            showErrorMessage.value = true;
            // console.log('Error in Restart');
          }
        }
      } catch (error) {
        renderReady.value = true;
        // localStorage.setItem('errorMsg', 'There is an issue in the restart Journey');
        // router.push({ path: 'Error' });
        console.log(error);
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue in the restart Journey, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const setTaskdetails = (taskDetails: any) => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // const res: any = await getTaskById(taskId.value);
      console.log(`task data ${JSON.stringify(taskDetails)}`);
      const taskRes = taskDetails;
      renderReady.value = true;
      if (taskRes) {
        taskId.value = taskRes.task_id;
        taskType.value = taskRes.task_type;
        taskName.value = taskRes.task_name;
        taskDesc.value = taskRes.description;
        skillId.value = taskRes.skill;
        proficiencyId.value = taskRes.proficiency;
        linkedTask.value = taskRes.linked_task_group;
        checkForPlagiarismTaskLevel.value = taskRes.checkForPlagiarism === true;
      } else {
        // renderReady.value = true;
        // localStorage.setItem('errorMsg', 'There is an issue to fetch task');
        // router.push({ path: 'Error' });
        errorResponse.value = 'There is an issue to fetch task, please contact helpmate.';
        showErrorMessage.value = true;
      }
    };
    onBeforeMount(async () => {
      try {
        renderReady.value = false;
        programName.value = localStorage.getItem('programName');
        reviewerAssignmentStrategy.value = localStorage.getItem('reviewerAssignmentStrategy');
        taskAssignmentStrategy.value = localStorage.getItem('taskAssignmentStrategy');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getExistedLearner('/learner/journey/stat', { skill: skillId.value, proficiency: proficiencyId.value, program_id: programId.value });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const existingRecord: any = res.data;
        stat.value = res.data;
        setTaskdetails(existingRecord.taskDetails);
        if (programName.value === 'infinity') fetchMinimumWordLength();

        checkForPlagiarismProgramLevel.value = existingRecord.program_details.plagiarism_enabled === true;
        // console.log(checkForPlagiarismProgramLevel.value, checkForPlagiarismTaskLevel.value);
        renderReady.value = true;
        if (existingRecord.learnerData) {
          if (existingRecord.learnerData.technical_hold) {
            console.log('learner on hold select task');
            router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: proficiencyId.value, program_id: programId.value } });
          }
          console.log(`learner Data value ${JSON.stringify(existingRecord.learnerData)}`);
          console.log(`learnerStatus value ${existingRecord.learnerData.learner_status}`);
          learnerStatus.value = existingRecord.learnerData.learner_status;
          learnerTaskId.value = existingRecord.learnerData.learner_task_id;
          if (existingRecord.learnerData.learner_status === 'Need Reviewer and Need Reviewee' || existingRecord.learnerData.learner_status === 'Need Reviewee') {
            router.push({ name: 'SolidifyLearnerPeerReview', query: { learner_task_id: existingRecord.learnerData.learner_task_id } });
          } else if (existingRecord.learnerData.learner_status === 'Need Reviewer' || existingRecord.learnerData.learner_status === 'Passed') router.push({ name: 'SolidifyLearnerDone', query: { learner_task_id: learnerTaskId.value } });
        }
      } catch (error) {
        renderReady.value = true;
        // localStorage.setItem('errorMsg', 'There is an issue to fetch existing record');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue to fetch existing record, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    });
    onUnmounted(() => {
      if (pollInterval) clearInterval(pollInterval);
    });

    return {
      stat,
      // fileName,
      genAIPromptResp,
      loadingGenAIResponse,
      isEligibleForAIAssist,
      learnerSubmissionFile,
      reviewPopupOpened,
      proceedToReview,
      // mobileSubmission,
      skillName,
      profName,
      skillId,
      proficiencyId,
      programId,
      taskType,
      taskName,
      taskDesc,
      linkedTask,
      userRating,
      userComment,
      submitSubmiision,
      learnerSubmission,
      selectedFile,
      fileValidationMsg,
      restart,
      switchTask,
      learnerTaskId,
      preSignedUrl,
      buttonDisable,
      validationError,
      clearFile,
      fileInputKey,
      helpmateLink,
      learnerStatus,
      renderReady,
      errorResponse,
      showErrorMessage,
      plagiarismcb,
      palgiarismErrorMsg,
      programName,
      taskAssignmentStrategy,
      reviewerAssignmentStrategy,
      checkForPlagiarismTaskLevel,
      checkForPlagiarismProgramLevel,
      checkQuestionLength,
      questionWordCount,
      submissionError,
      moment,
      minimumWordLength,
    };
  },
});
